var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil } from 'lodash-es';
import { SortInfo } from '../../shared/context-menu/item-search-sort';
import { SdsContextMenuSelectItem } from '../item/sds-cm-select-item.lit';
import styles from './sds-cm-group.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-cm-group` is a web component that acts as a container for organizing related items
 * within a context menu. It allows developers to group multiple context menu items together,
 * providing a clear visual distinction and improving the user experience by categorizing actions.
 *
 * ### Features:
 * - Groups related context menu items for better organization.
 * - Supports customizable titles for the group.
 */
let SdsContextMenuGroup = (() => {
    var _SdsContextMenuGroup_name_accessor_storage, _SdsContextMenuGroup_collapsible_accessor_storage, _SdsContextMenuGroup_disabled_accessor_storage, _SdsContextMenuGroup__identifier_accessor_storage, _SdsContextMenuGroup__value_accessor_storage, _SdsContextMenuGroup__contentContainer_accessor_storage, _SdsContextMenuGroup__contentHidden_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-cm-group')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _collapsible_decorators;
    let _collapsible_initializers = [];
    let _collapsible_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _set_identifier_decorators;
    let _set_value_decorators;
    let __contentContainer_decorators;
    let __contentContainer_initializers = [];
    let __contentContainer_extraInitializers = [];
    let __contentHidden_decorators;
    let __contentHidden_initializers = [];
    let __contentHidden_extraInitializers = [];
    var SdsContextMenuGroup = _classThis = class extends _classSuper {
        /**
         * The name of the group, which is displayed as a label above the group items.
         * This helps users identify the category of actions contained within the group.
         *
         * Defaults to an empty string.
         *
         * @attr {string} name - The label for the group.
         */
        get name() { return __classPrivateFieldGet(this, _SdsContextMenuGroup_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup_name_accessor_storage, value, "f"); }
        /**
         * Indicates whether the group is collapsible.
         * If set to `true`, users can collapse or expand the group to show or hide its items,
         * enhancing the organization of the context menu.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} collapsible - Enables collapsible functionality for the group.
         */
        get collapsible() { return __classPrivateFieldGet(this, _SdsContextMenuGroup_collapsible_accessor_storage, "f"); }
        set collapsible(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup_collapsible_accessor_storage, value, "f"); }
        /**
         * Indicates whether the group is disabled.
         * When `true`, the group and its items are non-interactive, preventing any actions
         * from being triggered within the group.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} disabled - Marks the group as disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsContextMenuGroup_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup_disabled_accessor_storage, value, "f"); }
        /**
         * A unique identifier for the group.
         * This can be used for programmatic access or to distinguish between multiple groups
         * within the context menu.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} identifier - A unique identifier for the group.
         */
        get _identifier() { return __classPrivateFieldGet(this, _SdsContextMenuGroup__identifier_accessor_storage, "f"); }
        set _identifier(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup__identifier_accessor_storage, value, "f"); }
        set identifier(identifier) {
            this._identifier = identifier;
            this._value = identifier;
        }
        get identifier() {
            return this._identifier;
        }
        /**
         * A unique value for the group.
         * This can be used for programmatic access or to distinguish between multiple groups
         * within the context menu.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} value - A unique value for the group.
         */
        get _value() { return __classPrivateFieldGet(this, _SdsContextMenuGroup__value_accessor_storage, "f"); }
        set _value(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup__value_accessor_storage, value, "f"); }
        set value(value) {
            this._value = value;
            this.identifier = value;
        }
        get value() {
            return this._value;
        }
        get _contentContainer() { return __classPrivateFieldGet(this, _SdsContextMenuGroup__contentContainer_accessor_storage, "f"); }
        set _contentContainer(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup__contentContainer_accessor_storage, value, "f"); }
        get _contentHidden() { return __classPrivateFieldGet(this, _SdsContextMenuGroup__contentHidden_accessor_storage, "f"); }
        set _contentHidden(value) { __classPrivateFieldSet(this, _SdsContextMenuGroup__contentHidden_accessor_storage, value, "f"); }
        get content() {
            this.onContentChange();
            return this._content;
        }
        get filteredContent() {
            return this._filteredContent;
        }
        get contentContainer() {
            if (isNil(this._contentContainer)) {
                throw new Error('Content container not found');
            }
            else {
                return this._contentContainer;
            }
        }
        render() {
            return html `
            ${this.renderGroupHeading()}
            <div id="group-content"></div>
            <slot style="display: none;" @slotchange="${this.onContentChange}"></slot>
        `;
        }
        renderGroupHeading() {
            if (this.name) {
                return html `
                <sds-cm-item
                    ?with-icon="${this.collapsible}"
                    name="${this.name}"
                    heading
                    ?disabled="${this.disabled}"
                >
                    ${this.renderGroupIcon()}
                </sds-cm-item>
            `;
            }
        }
        getPrimaryField() {
            return undefined;
        }
        // region search item implementation
        getSecondaryField() {
            return undefined;
        }
        applySearchAndReturnSortInfo(searchFilter) {
            const items = this._content
                .map(item => {
                let sortInfo;
                if (item instanceof SdsContextMenuSelectItem) {
                    sortInfo = item.applySearchAndReturnSortInfo(searchFilter);
                }
                else {
                    sortInfo = SortInfo.NOT_FOUND;
                }
                return {
                    sortInfo,
                    item,
                };
            })
                .filter(meta => meta.sortInfo.isFound())
                .sort((a, b) => SortInfo.compareFn(a.sortInfo, b.sortInfo));
            if (items.length > 0) {
                this.style.display = 'block';
                this._filteredContent = items.map(meta => meta.item);
                this.contentContainer.classList.remove('sds-cm-group__content--hidden');
                this._contentHidden = false;
                this.renderContent();
                return items[0].sortInfo;
            }
            else {
                this.style.display = 'none';
                return SortInfo.NOT_FOUND;
            }
        }
        getClasses() {
            return classMap({
                'sds-cm-group': true,
                'sds-cm-group--disabled': this.disabled,
            });
        }
        /**
         * TODO: REFACTOR NEEDED - aria-activedescendant Issue
         *
         * Current Problem:
         * - sds-cm-select-items are moved to the group's shadow root via renderContent()
         * - This breaks aria-activedescendant functionality because:
         *   1. The input (in select component) can't reference items in the group's shadow root
         *   2. aria-activedescendant requires items to be in the same DOM tree or accessible via ID
         *   3. Shadow DOM boundaries prevent cross-shadow-root element references
         *
         * Solution:
         * - Move items from shadow root back to the slot
         * - Keep items in the light DOM so aria-activedescendant can reference them
         * - This will restore proper accessibility for screen readers
         *
         * Impact:
         * - Currently, screen readers can't announce focused items in groups
         * - Users lose accessibility feedback when navigating grouped select items
         * - This affects WCAG compliance for select components with groups
         */
        renderContent() {
            var _a;
            const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#group-content');
            if (container) {
                container.innerHTML = '';
                container.append(...this._filteredContent);
            }
        }
        toggleGroupContent() {
            if (this._contentHidden) {
                this.contentContainer.classList.remove('sds-cm-group__content--hidden');
                this._contentHidden = false;
            }
            else {
                this.contentContainer.classList.add('sds-cm-group__content--hidden');
                this._contentHidden = true;
            }
        }
        renderGroupIcon() {
            if (this.collapsible) {
                return html `
                <sds-button
                    @click="${() => this.toggleGroupContent()}"
                    slot="icon"
                    size="sm"
                    type="tertiary"
                    icon="${this._contentHidden ? 'arrow_right_thin' : 'arrow_down_thin'}"
                ></sds-button>
            `;
            }
            else {
                return undefined;
            }
        }
        constructor() {
            super(...arguments);
            _SdsContextMenuGroup_name_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _name_initializers, '')));
            _SdsContextMenuGroup_collapsible_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _collapsible_initializers, false)));
            _SdsContextMenuGroup_disabled_accessor_storage.set(this, (__runInitializers(this, _collapsible_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsContextMenuGroup__identifier_accessor_storage.set(this, __runInitializers(this, _disabled_extraInitializers));
            _SdsContextMenuGroup__value_accessor_storage.set(this, undefined);
            this.setPrimaryFieldHighlight = undefined;
            this.setSecondaryFieldHighlight = undefined;
            this.getHighlightClass = undefined;
            this._content = [];
            this._filteredContent = [];
            this.onContentChange = () => {
                var _a, _b;
                const items = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot')) === null || _b === void 0 ? void 0 : _b.assignedElements({
                    flatten: false,
                });
                items.forEach(item => {
                    if (!this._content.includes(item)) {
                        if (this.disabled) {
                            item.disabled = true;
                        }
                        this._content.push(item);
                    }
                });
                this._filteredContent = this._content;
                this.renderContent();
            };
            _SdsContextMenuGroup__contentContainer_accessor_storage.set(this, __runInitializers(this, __contentContainer_initializers, void 0));
            _SdsContextMenuGroup__contentHidden_accessor_storage.set(this, (__runInitializers(this, __contentContainer_extraInitializers), __runInitializers(this, __contentHidden_initializers, false)));
            __runInitializers(this, __contentHidden_extraInitializers);
        }
    };
    _SdsContextMenuGroup_name_accessor_storage = new WeakMap();
    _SdsContextMenuGroup_collapsible_accessor_storage = new WeakMap();
    _SdsContextMenuGroup_disabled_accessor_storage = new WeakMap();
    _SdsContextMenuGroup__identifier_accessor_storage = new WeakMap();
    _SdsContextMenuGroup__value_accessor_storage = new WeakMap();
    _SdsContextMenuGroup__contentContainer_accessor_storage = new WeakMap();
    _SdsContextMenuGroup__contentHidden_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsContextMenuGroup");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _name_decorators = [property()];
        _collapsible_decorators = [property({
                type: Boolean,
                attribute: 'collapsible',
            })];
        _disabled_decorators = [property({ type: Boolean })];
        _set_identifier_decorators = [property()];
        _set_value_decorators = [property()];
        __contentContainer_decorators = [query('#group-content')];
        __contentHidden_decorators = [state()];
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _collapsible_decorators, { kind: "accessor", name: "collapsible", static: false, private: false, access: { has: obj => "collapsible" in obj, get: obj => obj.collapsible, set: (obj, value) => { obj.collapsible = value; } }, metadata: _metadata }, _collapsible_initializers, _collapsible_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _set_identifier_decorators, { kind: "setter", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_value_decorators, { kind: "setter", name: "value", static: false, private: false, access: { has: obj => "value" in obj, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, __contentContainer_decorators, { kind: "accessor", name: "_contentContainer", static: false, private: false, access: { has: obj => "_contentContainer" in obj, get: obj => obj._contentContainer, set: (obj, value) => { obj._contentContainer = value; } }, metadata: _metadata }, __contentContainer_initializers, __contentContainer_extraInitializers);
        __esDecorate(_classThis, null, __contentHidden_decorators, { kind: "accessor", name: "_contentHidden", static: false, private: false, access: { has: obj => "_contentHidden" in obj, get: obj => obj._contentHidden, set: (obj, value) => { obj._contentHidden = value; } }, metadata: _metadata }, __contentHidden_initializers, __contentHidden_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenuGroup = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenuGroup = _classThis;
})();
export { SdsContextMenuGroup };
